<mat-card class="preset-overview-card">
    <mat-card-header>
        <mat-card-title [attr.data-uiid]="'preset-overview-header-title'"
            >All available presets</mat-card-title
        >
    </mat-card-header>

    <mat-divider></mat-divider>

    <mat-card-content>
        <mat-grid-list rowHeight="1.5:1" gutterSize="1rem" cols="4">
            @for (preset of presets; track preset; let i = $index) {
                <mat-grid-tile>
                    <mat-card
                        [attr.data-uiid]="'preset-overview-preset-card-' + i"
                        class="preset-card"
                        [class.preset-selected]="activePresetId === preset.id"
                    >
                        <mat-card-header>
                            <mat-card-title>
                                <div
                                    class="preset-title"
                                    [matTooltip]="preset.name"
                                    matTooltipClass="cerrix-tooltip"
                                    matTooltipShowDelay="300"
                                    [attr.data-uiid]="'preset-overview-preset-title-' + i"
                                >
                                    @if (preset.icon) {
                                        <mat-icon>{{ preset.icon }}</mat-icon>
                                    }
                                    {{ preset.name }}
                                </div>
                                <mat-chip disabled>rolegroup</mat-chip>
                            </mat-card-title>
                            <mat-card-subtitle
                                [attr.data-uiid]="'preset-overview-preset-subtitle-' + i"
                                class="preset-subtitle"
                            >
                                @if (preset.predefined) {
                                    <span>System preset</span>
                                } @else {
                                    <span>Preset created by {{ preset.createdBy }} </span>
                                    @if (preset.modifiedOn) {
                                        <span>
                                            Last updated on
                                            {{ preset.modifiedOn | dateTimeDisplay }}
                                        </span>
                                    }
                                }
                            </mat-card-subtitle>
                        </mat-card-header>
                        <mat-card-content>
                            <p
                                class="preset-description"
                                [attr.data-uiid]="'preset-overview-preset-description-' + i"
                                [matTooltip]="preset.description"
                                matTooltipClass="cerrix-tooltip"
                                matTooltipShowDelay="300"
                            >
                                {{ preset.description }}
                            </p>
                        </mat-card-content>
                        <mat-card-actions>
                            <button
                                mat-icon-button
                                matTooltip="Apply"
                                [attr.data-uiid]="'preset-overview-preset-apply-button-' + i"
                                matTooltipClass="cerrix-tooltip"
                                showDelay="300"
                                [disabled]="preset.id === activePresetId"
                                (click)="applyPreset(preset.id)"
                            >
                                <mat-icon>play_circle_outline</mat-icon>
                            </button>
                            <button
                                mat-icon-button
                                matTooltip="Set as default"
                                matTooltipClass="cerrix-tooltip"
                                showDelay="300"
                                [attr.data-uiid]="
                                    preset.userDefault
                                        ? 'preset-overview-preset-default-button-active-' + i
                                        : 'preset-overview-preset-default-button-inactive-' + i
                                "
                                (click)="updateUserDefault(preset, !preset.userDefault)"
                                [color]="preset.userDefault ? 'primary' : ''"
                            >
                                <mat-icon>home_outline</mat-icon>
                            </button>
                            @if (
                                !preset.predefined && !preset.systemDefault && preset.isOwnPreset
                            ) {
                                <button
                                    mat-icon-button
                                    matTooltip="Public"
                                    matTooltipClass="cerrix-tooltip"
                                    showDelay="300"
                                    [attr.data-uiid]="
                                        preset.public
                                            ? 'preset-overview-preset-public-button-active-' + i
                                            : 'preset-overview-preset-public-button-inactive-' + i
                                    "
                                    (click)="
                                        updatePublic(
                                            preset.id,
                                            !preset.public,
                                            preset.systemDefault
                                        )
                                    "
                                    [color]="preset.public ? 'primary' : ''"
                                >
                                    <mat-icon>public</mat-icon>
                                </button>
                            }
                            <button
                                mat-icon-button
                                matTooltip="Favourite preset"
                                matTooltipClass="cerrix-tooltip"
                                showDelay="300"
                                [attr.data-uiid]="
                                    preset.favourite
                                        ? 'preset-overview-preset-favourite-button-active-' + i
                                        : 'preset-overview-preset-favourite-button-inactive-' + i
                                "
                                (click)="updateFavourite(preset, !preset.favourite)"
                                [color]="preset.favourite ? 'primary' : ''"
                            >
                                <mat-icon>{{
                                    preset.favourite ? "star" : "star_outline"
                                }}</mat-icon>
                            </button>
                            @if (
                                !preset.predefined && !preset.systemDefault && preset.isOwnPreset
                            ) {
                                <button
                                    mat-icon-button
                                    matTooltip="Delete preset"
                                    matTooltipClass="cerrix-tooltip"
                                    showDelay="300"
                                    [attr.data-uiid]="'preset-overview-preset-delete-button-' + i"
                                    (click)="deletePreset(preset.id)"
                                >
                                    <mat-icon>delete</mat-icon>
                                </button>
                            }
                            @if (canSetSystemDefault()) {
                                <button
                                    mat-icon-button
                                    matTooltip="System default"
                                    matTooltipClass="cerrix-tooltip"
                                    showDelay="300"
                                    [attr.data-uiid]="
                                        preset.systemDefault
                                            ? 'preset-overview-preset-system-default-button-active-' +
                                              i
                                            : 'preset-overview-preset-system-default-button-inactive-' +
                                              i
                                    "
                                    (click)="updateSystemDefault(preset.id, !preset.systemDefault)"
                                    [color]="preset.systemDefault ? 'primary' : ''"
                                >
                                    <mat-icon>home_work_outline</mat-icon>
                                </button>
                            }
                        </mat-card-actions>
                    </mat-card>
                </mat-grid-tile>
            }
        </mat-grid-list>
    </mat-card-content>

    <mat-card-footer> </mat-card-footer>
</mat-card>
